import { connect } from 'react-redux';

import AlertDeleteConfirmationDialog from './AlertDeleteConfirmationDialog';

import { removeAlert } from '@Pages/Alerts/AlertsAction';

const mapDispatchToProps = {
  removeAlert,
};

export default connect(null, mapDispatchToProps)(AlertDeleteConfirmationDialog);
